import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { translate, SUPPORTED_LANGS } from "@/lib/i18n";

const LangContext = createContext({
  lang: "fr",
  setLang: () => {},
  t: (k) => k,
  languages: SUPPORTED_LANGS,
});

const STORAGE_KEY = "saor_lang";

function detectInitialLang() {
  if (typeof window === "undefined") return "fr";
  const stored = window.localStorage?.getItem(STORAGE_KEY);
  if (stored && SUPPORTED_LANGS.some((l) => l.code === stored)) return stored;
  // Auto-detect from navigator.language (fr-FR → fr).
  const nav = (navigator.language || navigator.userLanguage || "fr").slice(0, 2);
  return SUPPORTED_LANGS.some((l) => l.code === nav) ? nav : "fr";
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(detectInitialLang);

  const setLang = useCallback((code) => {
    if (!SUPPORTED_LANGS.some((l) => l.code === code)) return;
    setLangState(code);
    try { window.localStorage.setItem(STORAGE_KEY, code); } catch (_) { /* ignore */ }
  }, []);

  // Sync <html lang="..."> for accessibility + browser toolbars.
  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key, params) => translate(lang, key, params), [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t, languages: SUPPORTED_LANGS }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
